<coin-employee-picture
  size="large"
  [gid]="comment()?.createdBy?.gid"></coin-employee-picture>
<div class="comment-text">
  <div
    class="name-and-time"
    [class.reverse]="isOwnComment()">
    <p class="bold">{{ (comment()?.createdBy | employeeName) || ('general.system' | translate) }}</p>
    <p class="bold time">{{ comment()?.createdAt | date: 'HH:mm' }} UTC</p>
    @if (commentExtension()) {
      <ng-container
        [ngTemplateOutlet]="commentExtension()!"
        [ngTemplateOutletContext]="{ $implicit: comment() }"></ng-container>
    }
  </div>
  @if (comment()?.createdBy?.gid) {
    <p class="gid">GID: {{ comment()?.createdBy?.gid }}</p>
  } @else {
    <p class="gid">&nbsp;</p>
  }
  <p class="message">
    {{ comment()?.value }}
  </p>
</div>
